<template>
  <el-container>
    <el-header class="header-box shadow" v-if="_global_.client != 'win'">
      <master-head-navigation :cardName="card_name" />
    </el-header>
    <el-main>
      <el-row class="wrapper">
        <el-row class="aside shadow">
          <el-row class="enterInfo">
            <el-row class="avator-box mb-10">
              <img class="avator" v-if="data.headimgurl" :src="data.headimgurl">
              <img class="avator" v-else src="../assets/images/default_img.png">
              <img v-if="data.auth=='PASSED'" class="auth-state" src="../assets/images/v-auth.png">
              <img v-else class="auth-state" src="../assets/images/v.png">
            </el-row>
            <h5 v-if="data.auth=='PASSED'" class="enterprise">{{data.enterprise_name}}</h5>
            <span v-else>未认证</span>
          </el-row>
          <el-aside>
            <!--侧边导航菜单-->
            <el-menu class="el-menu-demo" :default-openeds="openeds">
              <el-submenu v-for="(item, key) in menus" :key="key" :index="'a'+key" v-if="item.is_show_menu.name=='YES'">
                <template slot="title">
                  <i :class="'menu-icon xy '+item.menu_icon"></i>
                  <!-- <i class="el-icon-menu"></i> -->
                  <span>{{item.menu_name}}</span>
                </template>
                <el-menu-item @click="utils.toUrl(i.menu_url)" v-for="(i, k) in item.children" :key="k" :index="key+'-'+k" v-if="i.is_show_menu.name=='YES'">{{i.menu_name}}</el-menu-item>
              </el-submenu>
            </el-menu>
          </el-aside>
        </el-row>
        <el-row class="main">
          <router-view></router-view>
        </el-row>
      </el-row>
    </el-main>
    <el-footer class="footer-box" v-if="_global_.client != 'win'">
      <master-bottom />
    </el-footer>
  </el-container>
</template>
<script>
import MasterHeadNavigation from "@/components/master/master-head-navigation";
import MasterBottom from "@/components/master/master-bottom";
import { field } from "@/assets/js/consts";
import { refreshLoginInfo } from '@/assets/js/utils'
export default {
  data () {
    return {
      isCollapse: false,
      activeIndex: "1",
      // menus: [
      //   {
      //     is_show_menu: true,
      //     menu_icon: "xy-icon16",
      //     menu_name: "运单",
      //     children: [
      //       { menu_url: "/waybill/waybill-list", menu_name: "运单列表", is_show_menu: true },
      //       { menu_url: "/waybill/plan-list", menu_name: "计划单列表", is_show_menu: true },
      //       { menu_url: "/waybill/address-list", menu_name: "地址列表", is_show_menu: true },
      //       { menu_url: "/waybill/driver-list", menu_name: "司机列表", is_show_menu: true }
      //     ]
      //   },
      //   {
      //     is_show_menu: true,
      //     menu_icon: "xy-icon14",
      //     menu_name: "财务",
      //     children: [
      //       { menu_url: "/finance/pay", menu_name: "支付和发票", is_show_menu: true },
      //       { menu_url: "/finance/wallet", menu_name: "钱包和流水", is_show_menu: true }
      //     ]
      //   },
      //   {
      //     is_show_menu: true,
      //     menu_icon: "xy-icon2",
      //     menu_name: "设置",
      //     children: [
      //       { menu_url: "/set/agent", menu_name: "经纪人", is_show_menu: true },
      //       { menu_url: "/set/member", menu_name: "成员管理", is_show_menu: true },
      //       { menu_url: "/set/enter", menu_name: "企业信息", is_show_menu: true },
      //       { menu_url: "/set/pwd", menu_name: "设置密码", is_show_menu: true }
      //     ]
      //   }
      // ],
      menus: [],
      newsNum: 0,
      openeds: ['a0', 'a1', 'a2'],
      card_name: '',
      data: {
        enterprise_name: ' ',
        headimgurl: '',
        auth: '',
      }
    };
  },
  created () {
    this.loadInfo();
    this.loadMenu();
    refreshLoginInfo(this)
  },
  methods: {
    loadInfo () {
      this.api(150104, {}).then(res => {
        let data;
        if ((data = this.utils.isSuccess(res))) {
          // this.menus = data.menu_list;
          this.data.enterprise_name = data.enterprise_name;
          this.data.headimgurl = data.headimgurl;
          this.data.auth = data.audit_status.name;
          _global_.AUTH = data.audit_status.name;
          this.card_name = data.card_name;
        }
      });
    },
    loadMenu () {
      this.api(170204, { style: 'PC' }).then(res => {
        let data;
        if ((data = this.utils.isSuccess(res))) {
          this.menus = data;
        }
      });
    },
  },
  components: {
    MasterHeadNavigation,
    MasterBottom
  }
};
</script>

<style scoped lang="scss">
.el-container {
  height: 100%;
}
.header-box {
  background: #fff;
  height: 90px !important;
}
.footer-box {
  background: #333;
  height: auto !important;
}
.aside {
  margin-right: 20px;
  position: relative;
  top: 0;
  height: max-content;
}
.el-aside {
  width: 220px !important;
  overflow: hidden;
  .el-menu {
    border-right: none;
  }
}

.menu-icon {
  font-size: 24px;
  margin-right: 5px;
}
.enterInfo {
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 30px;
  padding-bottom: 30px;
  .avator-box {
    position: relative;
  }
  .avator {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    font-size: 20px;
    position: relative;
  }
  .auth-state {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 35px;
    right: 0;
  }
}
.enterprise {
  max-width: 200px;
  padding: 0 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/main.vue